<template>
	<!-- DCTL-2048 (Nav IA Phase 4): the orphaned-papers safety-net list. Reuses
	     the Paper Management table (PaperTable) in orphaned mode so it stays
	     visually + behaviourally identical to Paper Management - just scoped to
	     papers with no project, which the edit -> attach-to-project flow clears. -->
	<v-row align-content="start" justify="start">
		<v-col cols="12">
			<paper-table orphaned-mode />
		</v-col>
	</v-row>
</template>

<script>
import PaperTable from "@/pages/PaperManager/PaperTable";

export default {
	name: "OrphanedPapers",

	components: {
		PaperTable,
	},
};
</script>

<style scoped lang="scss">
.col {
	flex-grow: 0;
}
</style>
